import { RoleEnum } from 'src/slices/services/api'
import { DISPLAY_OPC_AS_EDITOR_STORE_MANAGER_ORG_CODES } from './org'

/**
 * RoleEnumの表示名マッピング
 */
type RoleTitleMap = {
  [key in RoleEnum]: string
}

export const roleTitleMap: RoleTitleMap = {
  [RoleEnum.Admin]: '全体管理者',
  [RoleEnum.AdminStoreManager]: '施設管理者',
  [RoleEnum.AdminSalesReportManager]: '売上担当者・責任者',
  [RoleEnum.EditorSalesReportManager]: '売上担当者・作業者',
  [RoleEnum.EditorStoreManagerInOperationCenter]: '施設担当者･OPC',
  [RoleEnum.EditorStoreManager]: '施設担当者',
  [RoleEnum.Viewer]: '閲覧者',
}

export const getRoleTitle = (orgCode: string, role?: RoleEnum): string => {
  if (!role) return ''

  if (role === RoleEnum.EditorStoreManagerInOperationCenter) {
    if (DISPLAY_OPC_AS_EDITOR_STORE_MANAGER_ORG_CODES.includes(orgCode)) {
      return '施設担当者'
    }
  }
  return roleTitleMap[role] ?? ''
}

export const AdminAdminStoreManagerRoles: RoleEnum[] = [
  RoleEnum.Admin,
  RoleEnum.AdminStoreManager,
]

export const AdminAllEditorStoreManagerInOperationCenterEditorStoreManagerRoles: RoleEnum[] =
  [
    RoleEnum.Admin,
    RoleEnum.AdminStoreManager,
    RoleEnum.AdminSalesReportManager,
    RoleEnum.EditorStoreManagerInOperationCenter,
    RoleEnum.EditorStoreManager,
  ]

export const AdminAdminSalesReportManagerEditorSalesReportManagerEditorStoreManagerInOperationCenterRoles: RoleEnum[] =
  [
    RoleEnum.Admin,
    RoleEnum.AdminSalesReportManager,
    RoleEnum.EditorSalesReportManager,
    RoleEnum.EditorStoreManagerInOperationCenter,
  ]

export const AdminAdminSalesReportManagerEditorSalesReportManagerRoles: RoleEnum[] =
  [
    RoleEnum.Admin,
    RoleEnum.AdminSalesReportManager,
    RoleEnum.EditorSalesReportManager,
  ]

export const AdminAdminSalesReportManagerRoles: RoleEnum[] = [
  RoleEnum.Admin,
  RoleEnum.AdminSalesReportManager,
]

export const AdminAdminSalesReportManagerEditorSalesReportManagerAdminStoreManagerEditorStoreManagerRoles: RoleEnum[] =
  [
    RoleEnum.Admin,
    RoleEnum.AdminSalesReportManager,
    RoleEnum.EditorSalesReportManager,
    RoleEnum.AdminStoreManager,
    RoleEnum.EditorStoreManager,
  ]

export const isOneOfRoles = (availableRoles: RoleEnum[], role?: RoleEnum) => {
  return role ? availableRoles.includes(role) : false
}
